import { Service } from './Service';

export abstract class ILoadaiService extends Service {
  abstract getDriverDefaultParameters(): Promise<any>;
}
